import api from "./api";

export interface Cliente {
  id: string;
  /** Código sequencial auto-gerado ("CLI-001", "CLI-002"...). Não editável. */
  codigo: string | null;
  nome: string;
  email: string | null;
  telefone: string | null;
  documento: string | null;
  observacoes: string | null;
  linkAssets: string | null;
  ativo: boolean;
  criadoEm: string;
  _count?: { projetos: number; usuarios: number };
  /** Horas estimadas contratadas (Σ horasEstimadas das tarefas dos projetos). */
  horasTotais?: number;
  /** Horas úteis trabalhadas (Σ TarefaSessao no horário comercial). */
  horasInvestidas?: number;
  /** Σ horasTotais - horasInvestidas (mínimo 0). */
  horasRestantes?: number;
}

export interface ProjetoDoCliente {
  id: string;
  nome: string;
  status: string;
  modalidade?: string;
  prazoEntrega?: string | null;
  prazoTexto?: string | null;
  fotoUrl?: string | null;
  tipo?: string;
  criadoEm: string;
  tarefasAbertas: number;
  tarefasTotal: number;
  tarefasAtrasadas: number;
}

export interface ClienteDetalhe extends Cliente {
  usuarios: { id: string; nome: string; email: string; ativo: boolean }[];
  projetos: ProjetoDoCliente[];
  resumo: {
    projetosAtivos: number;
    projetosFinalizados: number;
    tarefasAbertas: number;
    tarefasAtrasadas: number;
  };
}

export async function listarClientes() {
  const r = await api.get("/clientes");
  return r.data.data as Cliente[];
}

export async function buscarCliente(id: string) {
  const r = await api.get(`/clientes/${id}`);
  return r.data.data as ClienteDetalhe;
}

export async function criarCliente(dados: {
  nome: string;
  email?: string;
  telefone?: string;
  documento?: string;
  observacoes?: string;
  linkAssets?: string | null;
  criarUsuario?: boolean;
  senhaInicial?: string;
}) {
  const r = await api.post("/clientes", dados);
  return r.data.data as Cliente;
}

export async function atualizarCliente(id: string, dados: Partial<Cliente>) {
  const r = await api.patch(`/clientes/${id}`, dados);
  return r.data.data as Cliente;
}

export async function desativarCliente(id: string) {
  await api.delete(`/clientes/${id}`);
}

export async function excluirClientePermanente(id: string, forcar: boolean) {
  const url = `/clientes/${id}/permanente${forcar ? "?forcar=true" : ""}`;
  await api.delete(url);
}

export interface UsuarioCliente {
  id: string;
  nome: string;
  email: string;
  ativo: boolean;
  criadoEm: string;
}

export async function listarUsuariosCliente(clienteId: string) {
  const r = await api.get(`/clientes/${clienteId}/usuarios`);
  return r.data.data as UsuarioCliente[];
}

export async function criarUsuarioCliente(clienteId: string, dados: { nome: string; email: string; senha: string }) {
  const r = await api.post(`/clientes/${clienteId}/usuarios`, dados);
  return r.data.data as UsuarioCliente;
}

export async function atualizarUsuarioCliente(clienteId: string, userId: string, dados: Partial<{ nome: string; email: string; senha: string; ativo: boolean }>) {
  const r = await api.patch(`/clientes/${clienteId}/usuarios/${userId}`, dados);
  return r.data.data as UsuarioCliente;
}

export async function excluirUsuarioCliente(clienteId: string, userId: string) {
  await api.delete(`/clientes/${clienteId}/usuarios/${userId}`);
}
